import { Typography, TypographyProps } from '@mui/material';

export const PropertyGridCardContentTypography = (props: Omit<TypographyProps, 'variant'>) => (
  <Typography variant="body2" {...props} />
);
